import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest, makePostRequest, makeDeleteRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { fromTableViewList, fromTableView } from './serializers'

function* fetchUsers() {
  try {
    const url = '/v1/users'
    const users = yield makeGetRequest(url)

    yield put({
      type: ACT.USERS_FETCH_SUCCESS,
      payload: {
        users: users.content
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching States',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchTableViewList(action) {
  const { table } = action.payload
  try {
    const url = `/v1/users/prefs/${table}`
    const tableViewList = yield makeGetRequest(url)
    yield put({
      type: ACT.TABLE_VIEWS_LIST_FETCH_SUCCESS,
      payload: {
        tableViewList: fromTableViewList(tableViewList)
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Table View List',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* saveTableView(action) {
  const { table, view, title, isPublic } = action.payload
  try {
    let url = `/v1/users/prefs/${table}/${title}`
    if (isPublic) {
      url = `/v1/users/prefs/${table}/${title}/public`
    }
    const tableView = yield makePostRequest(url, view)

    yield put({
      type: ACT.TABLE_VIEWS_SAVE_SUCCESS,
      payload: {
        tableView: fromTableView(tableView)
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue saving Table View',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* deleteTableView(action) {
  const { table, id, title } = action.payload
  try {
    const url = `/v1/users/prefs/${table}/${title}`
    yield makeDeleteRequest(url)
    yield put({
      type: ACT.TABLE_VIEW_DELETE_SUCCESS,
      payload: {
        id
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue deleting Table View',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchTableView(action) {
  const { table, title } = action.payload
  try {
    if (title === -1) {
      yield put({
        type: ACT.TABLE_VIEW_FETCH_SUCCESS,
        payload: {
          tableView: {}
        }
      })
      return
    }

    const url = `/v1/users/prefs/${table}/${title}`
    const tableView = yield makeGetRequest(url)
    yield put({
      type: ACT.TABLE_VIEW_FETCH_SUCCESS,
      payload: {
        tableView
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Table View List',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalReviewers(action) {
  const { dealId } = action.payload
  try {
    const url = `/v1/users/proposalReviewers/${dealId}`
    const proposalReviewers = yield makeGetRequest(url)
    yield put({
      type: ACT.PROPOSAL_REVIWEWERS_FETCH_SUCCESS,
      payload: {
        proposalReviewers
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposal Reviewers',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const usersSagas = [
  takeLatest(ACT.USERS_FETCH_REQUESTED, fetchUsers),
  takeLatest(ACT.TABLE_VIEWS_LIST_FETCH_REQUESTED, fetchTableViewList),
  takeLatest(ACT.TABLE_VIEWS_SAVE_REQUESTED, saveTableView),
  takeLatest(ACT.TABLE_VIEW_FETCH_REQUESTED, fetchTableView),
  takeLatest(ACT.PROPOSAL_REVIWEWERS_FETCH_REQUESTED, fetchProposalReviewers),
  takeLatest(ACT.TABLE_VIEW_DELETE_REQUESTED, deleteTableView)
]

export default usersSagas
